import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components';
import { translate } from "react-i18next";
import TextInput from './../../../../../components/TextInput';
import DefaultButton from './../../../../../components/DefaultButton';
import messageManager from './../../../../../utilities/messageManager';
import { modalInstance } from './../../../../admin/Admin';
import loading from './../../../../../utilities/loading';

const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const CreatorWrapper = styled.div`
    width: 100%;
    display: flex;
    overflow-x: auto;
    align-items: center;
    input {
        min-width: 300px;
    }
    div {
        margin-left: 10px;
    }
`;

const Title = styled.div`
    margin-top: 40px;
    margin-bottom: 20px;
`;

const TableWrapper = styled.div`
    width: 100%;
    display: flex;
    overflow-x: auto;
`;

const Table = styled.table`
    width: 80%;
    height: calc(100% - 4px);
    border-collapse: collapse;
    th {
        text-align: left;
        border-bottom: 2px solid #265a9c;
    };
    tr {
        font-size: 15px;
    };
    tr:last-child {
        border-bottom: 2px solid #265a9c;
        padding-bottom: 10px;
    };
    tr:last-child>td {
        padding-bottom: 10px;
    };
    td {
        padding: 10px 0 0 10px;
    };
`;

const CellWrapper = styled.td`
    >div {
        display: flex;
    };
`;

class ProjectAdmin extends React.Component {
    constructor(props) {
        super();
        this.state = {
            name: '',
            description: '',
            createBtnDisabled: false,
            deleteBtnDisabled: false,
        }
    }

    componentDidUpdate(prevProps){
        const { projects, chosenCustomer } = this.props;
        if(projects.length !== prevProps.projects.length){
            this.setState({createBtnDisabled : projects.length >= chosenCustomer.license.workspacesCountLimit})
        }
    }

    createProject() {
        const { BASE_URL, t, axiosInstance, chosenCustomer, getProjects, projects } = this.props;
        const { name, description } = this.state;
        if(projects.length + 1 > chosenCustomer.license.workspacesCountLimit){
            messageManager.show({
                text: t('Workspace count limit reached'),
                type: 'error',
            })
            return;
        }

        this.setState({ createBtnDisabled: true });
        loading.start();

        axiosInstance.post(`${BASE_URL}workspaces`,
            {
                name: name,
                description: description,
                customerId: chosenCustomer.id
            })
            .then((result) => {
                getProjects();
                messageManager.show({
                    type: 'info',
                    text: t('Workspace created')
                });
                loading.stop();
            })
            .catch((error) => {
                messageManager.show({
                    type: 'error',
                    text: t(error.response.data ? error.response.data : t('Error occured while creating workspace')),
                });
                loading.stop();
            });
    }

    deleteProject(e) {
        const { BASE_URL, t, axiosInstance, getProjects } = this.props;
        const project = e.currentTarget.dataset;
        const confirmCallback = () => {
            this.setState({ deleteBtnDisabled: true });
            loading.start();

            axiosInstance.delete(`${BASE_URL}workspaces/${project.id}`)
                .then(() => {
                    getProjects();
                    messageManager.show({
                        text: t('Workspace deleted'),
                        type: 'info',
                    });
                    this.setState({ deleteBtnDisabled: false });
                    loading.stop();
                })
                .catch((error) => {
                    messageManager.show({
                        type: 'error',
                        text: t(error.response.data ? error.response.data : t('Error occured while deleting workspace')),
                    });
                    this.setState({ deleteBtnDisabled: false });
                    loading.stop();
                });
        }

        const cancelCallback = () => { }

        const config = {
            title: t('Do you really want to delete workspace') + '?',
            content: <p>{t('Do you really want to delete workspace')} <b>{String(project.name)}</b>? {t('All data related with workspace will be lost')}</p>,
            confirmCallback: confirmCallback,
            cancelCallback: cancelCallback,
            confirmBtnVisible: true,
            cancelBtnVisible: true,
            confirmBtnText: t('Delete'),
            closeOnConfirm: true,
            type: 'warning',
        }
        modalInstance.customize(config);
        modalInstance.show();  
    }

    getProjectList() {
        const { projects, roles, t } = this.props;
        const projectList = projects.map((project) =>
            <tr key={project.id}>
                <td> {project.name} </td>
                <td> {project.description} </td>
                {(roles === 'Admin' || roles === 'SuperAdmin')
                    && <CellWrapper>
                        <div>
                            <DefaultButton
                                type='warning'
                                data-id={project.id}
                                data-name={project.name}
                                disabled={this.state.deleteBtnDisabled}
                                onClick={this.deleteProject.bind(this)}>
                                {t('Delete')}
                            </DefaultButton>
                        </div>
                    </CellWrapper>
                }
            </tr>
        )

        return <Table>
                <thead>
                    <tr>
                        <th>{t('Name')}</th>
                        <th>{t('Description')}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {projectList}
                </tbody>
            </Table>
    }

    render() {
        const { t, chosenCustomer, projects } = this.props;
        const { license, currentDataSize } = chosenCustomer;
        return (
            <React.Fragment>
                <HeaderWrapper>
                    <span>{`${t('Your current license type')}:`} <b>{`${license.name}`}</b> </span>
                    <span>{`${t('Workspace limit for that license')}:`} <b>{`${license.workspacesCountLimit}`}</b></span>
                    <span>{`${t('Your current workspace size')}:`} <b>{`${currentDataSize/1000}/${license.dataSizeLimitInMb/1000} GB`}</b></span>
                </HeaderWrapper>
                {projects.length > 0
                    ? <React.Fragment>
                        <Title> {t('Projects')}: </Title>
                        <TableWrapper> {this.getProjectList()} </TableWrapper>
                    </React.Fragment>
                    : null
                }
                <Title>{t('Create workspace')}:</Title>
                <CreatorWrapper>
                    <TextInput
                        placeholder={t('Name')}
                        value={this.state.name}
                        onChange={(e) => { this.setState({ name: e.target.value }) }}
                        type="text" />
                    <TextInput
                        placeholder={t('Description')}
                        value={this.state.description}
                        onChange={(e) => { this.setState({ description: e.target.value }) }}
                        type="text" />
                    <DefaultButton
                        style={{ minWidth: '64px', height: '22px'}}
                        disabled={this.state.createBtnDisabled}
                        onClick={() => this.createProject()}>
                        {t('Create')}
                    </DefaultButton>
                </CreatorWrapper>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => ({
    axiosInstance: state.auth.get('axiosInstance'),
    BASE_URL: state.domainProperties.get('BASE_URL'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(ProjectAdmin));



// WEBPACK FOOTER //
// ./src/containers/content/grid/adminPanel/projectAdmin/ProjectAdmin.jsx